export type { SomeResultProps } from './some';
export { default as SearchResultSome } from './some';
